const WarningIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="39"
    viewBox="0 0 45 39"
    fill="none"
    className="self-start"
  >
    <path
      d="M44.1038 35.3325L24.4575 1.30126C24.0525 0.600012 23.3025 0.168762 22.4925 0.168762C21.6825 0.168762 20.9325 0.600012 20.5275 1.30126L0.881265 35.3325C0.476265 36.0338 0.476265 36.9 0.881265 37.6013C1.28626 38.3025 2.03626 38.7338 2.84626 38.7338H42.1425C42.9525 38.7338 43.7025 38.3025 44.1075 37.6013C44.5088 36.8963 44.5088 36.0338 44.1038 35.3325ZM6.77626 34.1963L22.4925 6.97126L38.2088 34.1963H6.77626Z"
      fill="#AA1E1E"
    />
    <path
      d="M24.1013 28.3537C23.67 27.9712 23.1375 27.78 22.4925 27.78C21.8513 27.78 21.315 27.9712 20.8838 28.3537C20.4525 28.7362 20.2388 29.2237 20.2388 29.8162C20.2388 30.4087 20.4525 30.8962 20.8838 31.2787C21.3113 31.6612 21.8475 31.8525 22.4925 31.8525C23.1338 31.8525 23.67 31.6612 24.1013 31.2787C24.5288 30.8962 24.7463 30.4087 24.7463 29.8162C24.7425 29.22 24.5288 28.7325 24.1013 28.3537Z"
      fill="#AA1E1E"
    />
    <path
      d="M20.88 26.085H24.165L24.6825 14.1038H20.3625L20.88 26.085Z"
      fill="#AA1E1E"
    />
  </svg>
);

export default WarningIcon;
